import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const ReportIcon: React.FC<SVGIconProps> = ({ fill, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 12 14" {...props}>
            <title>Report</title>
            <g
                id="REPORT"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="03_Webreport-v3"
                    transform="translate(-12.000000, -111.000000)"
                >
                    <g id="Group-57" transform="translate(0.000000, 98.500000)">
                        <g id="Elements-/-Menu-/-Mainmenu">
                            <g
                                id="ICON_report"
                                transform="translate(6.000000, 7.000000)"
                            >
                                <g
                                    id="Elements-/-Section-opener-/-Blue"
                                    transform="translate(-11.000000, -5.500000)"
                                >
                                    <rect
                                        id="Rectangle-8"
                                        x="0"
                                        y="0"
                                        width="35"
                                        height="35"
                                    ></rect>
                                </g>
                                <g
                                    transform="translate(6.857143, 5.485714)"
                                    fill={fill ?? '#09293E'}
                                    fillRule="nonzero"
                                    id="Shape"
                                >
                                    <path d="M10.9714286,2.74297566 L10.9714286,13.0283731 C10.9714286,13.2103012 10.8994259,13.3845112 10.7708415,13.5130704 C10.6422571,13.6416297 10.4680518,13.7142857 10.2861113,13.7142857 L0.685317242,13.7142857 C0.306657289,13.7142857 0,13.4070074 0,13.0283731 L0,2.74297566 C0,2.36434138 0.306657289,2.05706308 0.685317242,2.05706308 L2.05721897,2.05706308 L2.05721897,2.74297566 L0.685317242,2.74297566 L0.685317242,13.0283731 L10.2861113,13.0283731 L10.2861113,2.74297566 L8.9142096,2.74297566 L8.9142096,2.05706308 L10.2861113,2.05706308 C10.4680518,2.05706308 10.6422735,2.12970431 10.7708415,2.25827836 C10.8994094,2.38685241 10.9714286,2.56104755 10.9714286,2.74297566 Z M6.85699052,1.37180874 C6.85699052,0.613898358 6.2430341,0 5.48573066,0 C4.72842722,0 4.11447079,0.613914814 4.11447079,1.37180874 L2.74256908,1.37180874 L2.74256908,3.42888827 L8.22826684,3.42888827 L8.22890985,1.37180874 L6.85699052,1.37180874 Z M9.60016896,4.80005526 L1.3712928,4.80005526 L1.3712928,5.48596785 L9.60016896,5.48596785 L9.60016896,4.80005526 Z M9.60016896,6.85713436 L1.3712928,6.85713436 L1.3712928,7.54304695 L9.60016896,7.54304695 L9.60016896,6.85713436 Z M9.60016896,8.91421443 L1.3712928,8.91421443 L1.3712928,9.60012703 L9.60016896,9.60012703 L9.60016896,8.91421443 Z M9.60016896,10.9712939 L1.3712928,10.9712939 L1.3712928,11.6572065 L9.60016896,11.6572065 L9.60016896,10.9712939 Z"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export default ReportIcon
